// Las tres sugerencias de la portada del Catálogo (ADR-2026-10-13-catalogo-con-el-agente), las de
// Hogar; las de los otros rubros van abajo (ADR-2026-10-26-el-catalogo-se-adapta-al-rubro):
// completan la caja sin enviar, como las de `InicioAgente`. UNA fuente: `estilosAgente.ts` las
// importa de acá para el panel del agente abierto desde esta pantalla.
import { Layers, Package, Ruler, Sofa, Sparkles, type LucideIcon } from 'lucide-react';
import { esRubroHogarDeco } from '../../../../lib/rubro';

export interface SugerenciaDeCatalogo {
  key: string;
  label: string;
  prompt: string;
  Icon: LucideIcon;
}

export const SUGERENCIAS_DE_CATALOGO: SugerenciaDeCatalogo[] = [
  {
    key: 'packshot-ambientes',
    label: 'Packshot + 2 ambientes',
    prompt:
      'Quiero el catálogo de estos productos: un packshot en fondo blanco de cada uno y dos ambientes distintos, con la misma luz cálida en todo el catálogo. Mirá los productos y proponeme las tomas antes de escribir nada.',
    Icon: Package,
  },
  {
    key: 'fichas-con-medidas',
    label: 'Fichas con medidas',
    prompt:
      'Necesito una ficha de cada producto con sus medidas: una foto limpia de frente para la ficha técnica y un packshot en fondo blanco. Si a alguno le faltan las medidas, pedímelas antes de armar el plan.',
    Icon: Ruler,
  },
  {
    key: 'mismo-living',
    label: 'Mismo living para todo',
    prompt:
      'Quiero todos estos muebles fotografiados en el mismo living: luz natural de tarde, piso de madera clara y paredes blancas, para que el catálogo se vea parejo. Una foto de ambiente por producto y un detalle del material.',
    Icon: Sofa,
  },
];

/**
 * Las de un rubro que no es Hogar (ADR-2026-10-26-el-catalogo-se-adapta-al-rubro): sin livings ni
 * fichas de medidas, que son de muebles. Hablan del producto en general; el agente las aterriza
 * al rubro de la marca (skill catalogo-por-rubro).
 */
export const SUGERENCIAS_DE_CATALOGO_POR_RUBRO: SugerenciaDeCatalogo[] = [
  {
    key: 'packshot-escenas',
    label: 'Packshot + 2 escenas',
    prompt:
      'Quiero el catálogo de estos productos: un packshot en fondo blanco de cada uno y dos fotos en el lugar donde se usan, con la misma luz en todo el catálogo. Mirá los productos y proponeme las tomas antes de escribir nada.',
    Icon: Package,
  },
  {
    key: 'fotos-para-la-tienda',
    label: 'Fotos para la tienda',
    prompt:
      'Necesito las fotos de estos productos para mi tienda online: un packshot en fondo blanco, un detalle de lo que más vale de cada uno y una foto en uso. Mirá los productos y decime qué tomas les sirven.',
    Icon: Layers,
  },
  {
    key: 'mismo-estilo',
    label: 'Mismo estilo para todo',
    prompt:
      'Quiero que todo el catálogo se vea parejo: la misma luz, la misma superficie y la misma paleta en todas las fotos, pensadas para mi rubro. Proponeme un estilo y las tomas para cada producto.',
    Icon: Sparkles,
  },
];

/** Las de la portada y el panel del agente según el rubro: Hogar, las de siempre. */
export const sugerenciasDeCatalogo = (rubro?: string | null): SugerenciaDeCatalogo[] =>
  !rubro || esRubroHogarDeco(rubro) ? SUGERENCIAS_DE_CATALOGO : SUGERENCIAS_DE_CATALOGO_POR_RUBRO;
